const REWARD_OVERVIEW_TYPES = {
  STORE: 'STORE',
  MAIL: 'MAIL',
  EMAIL: 'EMAIL',
  DONATION: 'DONATION'
}

const REWARD_OVERVIEW_TYPES_ALL = 'ALL'
export { REWARD_OVERVIEW_TYPES, REWARD_OVERVIEW_TYPES_ALL }
